<template><Header /></template>
<script>
import Header from "../Home/Header.vue";
export default { name: "SiteHeader", components: { Header } };
</script>
